const HOUR = 3_600_000;
const MIN = 60_000;

/** Timeline windows; zoomed windows follow the playhead. */
export const zoomLevels = [
  { id: '24h', label: '24 h', span: 24 * HOUR, tick: HOUR, labelEvery: 3 * HOUR },
  { id: '6h', label: '6 h', span: 6 * HOUR, tick: 30 * MIN, labelEvery: HOUR },
  { id: '1h', label: '1 h', span: HOUR, tick: 5 * MIN, labelEvery: 15 * MIN },
] as const;

export type ZoomId = (typeof zoomLevels)[number]['id'];
